/**
 * The common catalog — scope sentences that repeat across domains, written
 * ONCE so every table says "respeita o filtro" the same way.
 *
 * A catalog is a function of `t` (the pt-BR text is the translation key), so
 * the entries are translated when the component builds them and the
 * translations pipeline registers every key on first use.
 *
 *   const SCOPE = commonScopes(t);
 *   explanation: { what: t('Soma das OS entregues.'), scope: SCOPE.franchiseFilterAndPeriod }
 */
export type Translate = (key: string, named?: Record<string, unknown>) => string;

export interface CommonScopes {
  franchiseFilter: string;
  period: string;
  franchiseFilterAndPeriod: string;
  localCurrency: string;
}

export const commonScopes = (t: Translate): CommonScopes => ({
  franchiseFilter: t('Respeita o filtro de franquias.'),
  period: t('Respeita o período escolhido no filtro.'),
  franchiseFilterAndPeriod: t('Respeita o filtro de franquias e o período.'),
  localCurrency: t('Valores na moeda local de cada franquia, sem conversão.'),
});
